import React from "react";

import { GoogleLogin } from '@react-oauth/google';

type Props = {
    onLogin: (type: string, data: unknown) => void
}

export const LoginGoogle = ({ onLogin }: Props) => {
    return (
        <GoogleLogin
            onSuccess={credentialResponse => {
                if (credentialResponse.credential) {
                    onLogin("google", { token: credentialResponse.credential, web: true })
                }
            }}
            onError={() => {
                console.log('Login Failed');
            }}
        />
    );
};
